import { Flex, Box, Text } from '@chakra-ui/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@morressier/alembic';
import { ReactElement } from 'react';

const SessionUpdateModal = ({
  isOpen,
  onClose,
  actionButton,
  message,
  title,
  icon,
  isIconHide
}: {
  isOpen: boolean;
  onClose: () => void;
  actionButton: ReactElement;
  message: string | ReactElement;
  title?: string;
  icon?: IconProp;
  isIconHide?: boolean;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeButtonProps={{
        visibility: 'hidden'
      }}
      width="lg"
    >
      <Flex direction={'column'} padding={5} gap={3}>
        {!isIconHide && (
          <Box>
            <FontAwesomeIcon
              icon={icon ? icon : faTriangleExclamation}
              size="2x"
            />
          </Box>
        )}
        <Text textStyle={'headingGroup'}>
          {title ? title : 'Session Update Required'}
        </Text>
        <Text>{message}</Text>
        {actionButton && actionButton}
      </Flex>
    </Modal>
  );
};

export default SessionUpdateModal;
